






































































































































































































































import Vue from "vue";
import Notifications from "../../components/shared/Notifications.vue";
import UserSidebar from "../../components/controls/UserSidebar.vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { BusinessHourDTO, RangeTimeDTO } from "@/model/data.model";
import * as moment from "moment";
import ClickOutside from "vue-click-outside";
import { GenericService } from "@/services/GenericService";
import { SetupDropdownItemDTO } from "@/model/component.model";

type Navigation = { key: string; index: string; route: string; visible: any };
type DropdownMenuInfoItems = {
  link: string;
  name: string;
  needDivider: boolean;
  linkTarget?: string;
  isManual?: boolean;
};

@Component({
  components: {
    MbeNotifications: Notifications,
    MbeUserSidebar: UserSidebar
  },
  directives: {
    ClickOutside
  }
})
export default class Topbar extends Vue {
  $route: any;
  @Prop() showBreadcrumb: boolean;
  dialogVisible = false;
  dropdownMenuInfo = false;
  dropdownGridMenuInfo = false;
  setupFlag = false;
  isTradetermsActive = false;

  navigation: Navigation[] = [
    {
      key: "home",
      route: "ShipmentsMenuNew",
      index: "1",
      visible() {
        return true;
      }
    },
    {
      key: "shipments",
      route: "ShipmentsManagement",
      index: "2",
      visible() {
        return true;
      }
    },
    {
      key: "records",
      route: "ContactsList",
      index: "3",
      visible() {
        return true;
      }
    },
    {
      key: "billing",
      route: "BillingManagement",
      index: "4",
      visible: this.isBillingVisible
    }
  ];

  weekDays: string[] = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday"
  ];

  dropDownMenuItems: DropdownMenuInfoItems[] = [
    { link: "#", name: "Help", needDivider: false },
    { link: "#", name: "Training", needDivider: false },
    { link: "#", name: "Updates", needDivider: true },
    { link: "#", name: "Send feedback", needDivider: false }
  ];

  mockedSettings = [
    "ca",
    "de",
    "en",
    "es",
    "fr",
    "it",
    "pl",
    "pt",
    "ca",
    "de",
    "en",
    "es",
    "fr",
    "it",
    "pl",
    "pt",
    "ca",
    "de",
    "en",
    "es",
    "fr",
    "it",
    "pl",
    "pt"
  ];

  setupDropdownOptions: SetupDropdownItemDTO[] = [
    {
      command: "Setup",
      type: "ebay",
      title: "e_bay_setup",
      condition: this.$store.getters["customer/config"].ebayEnabled
    },
    {
      command: "Setup",
      type: "amazon",
      title: "amazon_setup",
      condition: this.$store.getters["customer/config"].amazonEnabled
    },
    {
      command: "DDPThirdPartCode",
      title: "ddp_third_part_code",
      condition: this.$store.getters.customer.config
        .canCustomizeStoredCustomDuties
    },
    {
      command: "EmailRegistration",
      title: "email_registration_setup",
      type: "emailRegistration",
      condition: this.$store.getters.customer.config
        .shipmentEmailsRegistrationEnabled
    },
    {
      command: "ApiKeySetup",
      type: "apikey",
      title: "apikey_setup",
      condition: this.enabledApiKey()
    },
    {
      command: "LoginHistory",
      type: "loginHistory",
      title: "login_history_menu",
      condition: true
    },
    {
      command: "DeviceManagement",
      type: "deviceManagement",
      title: "device_management_menu",
      condition: true
    },
    {
      command: "DefaultPackaging",
      type: "defaultPackaging",
      title: "default_packaging_setup",
      condition: this.$store.getters.customer.config.showDefaultPackageSettings
    }
  ];

  tradetermsDropdownOptions: Array<{
    command: string;
    title: string;
  }> = [
    {
      command: "TradetermsFuel",
      title: "tradeterms_fuel"
    }
  ];

  created() {
    this.setDropDownMenuItems();
  }

  async handleSetupDropdownClick(item: any) {
    if (this.$route.params.type !== item.type && item.type)
      return await this.$router.push({
        name: item.command,
        params: { type: item.type }
      });
    if (!item.type) {
      return await this.$router.push({ name: item.command });
    }
    return null;
  }

  onTradetermsDropdownItemClick(item: any) {
    this.$router.push({ name: item.command });
  }

  toggleDropdownMenuInfo() {
    this.dropdownMenuInfo = !this.dropdownMenuInfo;
  }

  isBillingVisible() {
    return this.$store.getters["customer/config"].showInvoices;
  }

  get isTradetermsVisible() {
    return this.$store.getters["customer/config"].showTradePrices;
  }

  closeDropdownMenuInfo() {
    this.dropdownMenuInfo = false;
  }

  toggleDropdownGridMenu() {
    this.dropdownGridMenuInfo = !this.dropdownGridMenuInfo;
  }

  closeDropdownGridMenu() {
    this.dropdownGridMenuInfo = false;
  }

  openManual(link: string) {
    GenericService.prototype
      .getPresignedUrl("tenants", link)
      .then((res: any) => {
        window.open(res);
      });
  }

  setDropDownMenuItems() {
    this.dropDownMenuItems = [] as DropdownMenuInfoItems[];
    if (this.$store.getters.features.new_manual) {
      GenericService.prototype
        .getFilesList(
          "tenants",
          `mbeonline/manual/${this.$store.getters.language}/`
        )
        .then((res: any) => {
          const file = res.find((el: any) => {
            return el.type === "FILE" && el.name.includes(".pdf");
          });
          if (file) {
            this.dropDownMenuItems.push({
              link: `mbeonline/manual/${this.$store.getters.language}/${file.name}`,
              name: String(this.$i18n.t("guide")),
              needDivider: false,
              linkTarget: "_blank",
              isManual: true
            });
          }
        });
    } else {
      if (this.$store.getters.language === "it") {
        this.dropDownMenuItems.push({
          link: "https://www.mbe.it/manuale-mbeonline",
          name: String(this.$i18n.t("guide")),
          needDivider: false,
          linkTarget: "_blank"
        });
      }
    }
  }

  get hasStoreContactName() {
    return this.$store.getters[
      "customer/storeInfo"
    ].contactReferences.some(ref => ref.type.includes("CONTACT_NAME"));
  }

  get hasStoreEmail() {
    return this.$store.getters[
      "customer/storeInfo"
    ].contactReferences.some(ref => ref.type.includes("EMAIL"));
  }

  get hasStorePhone() {
    return this.$store.getters[
      "customer/storeInfo"
    ].contactReferences.some(ref => ref.type.includes("TELEPHONE"));
  }

  get hasStoreFax() {
    return this.$store.getters[
      "customer/storeInfo"
    ].contactReferences.some(ref => ref.type.includes("FAX"));
  }

  get activeRoutingIndex() {
    if (!this.$route.meta || !this.$route.meta.breadcrumb) {
      this.setupFlag = false;
      return "1";
    } else if (
      this.$route.meta.breadcrumb === "ebay" ||
      this.$route.meta.breadcrumb === "amazon" ||
      this.$route.meta.breadcrumb === "apikey" ||
      this.$route.meta.breadcrumb === "settings" ||
      this.$route.meta.breadcrumb === "loginHistory" ||
      this.$route.meta.breadcrumb === "ddp_third_party_code" ||
      this.$route.meta.breadcrumb === "email_registration_setup" ||
      this.$route.meta.breadcrumb === "deviceManagement" ||
      this.$route.meta.breadcrumb === "defaultPackaging"
    ) {
      this.setupFlag = true;
      return "1";
    } else if (this.$route.meta.breadcrumb === "fuel-surcharge") {
      this.isTradetermsActive = true;
      return "1";
    }

    this.isTradetermsActive = false;
    this.setupFlag = false;
    return this.navigation.find(
      item => item.key === this.$route.meta.breadcrumb
    ).index;
  }

  userSidebarIsOpened = false;

  get storeAddress() {
    if (this.$store.getters["customer/storeAddresses"].length > 0) {
      return this.$store.getters["customer/storeAddresses"][0].address;
    } else {
      return "";
    }
  }

  get storeContactName() {
    if (this.hasStoreContactName) {
      return this.$store.getters["customer/storeInfo"].contactReferences
        .filter(ref => ref.type === "CONTACT_NAME")[0]
        .value.toUpperCase();
    } else {
      return "";
    }
  }

  get storeEmail() {
    if (this.hasStoreEmail) {
      return this.$store.getters[
        "customer/storeInfo"
      ].contactReferences.filter(ref => ref.type.includes("EMAIL"))[0].value;
    } else {
      return "";
    }
  }

  get storePhone() {
    if (this.hasStorePhone) {
      return this.$store.getters[
        "customer/storeInfo"
      ].contactReferences.filter(ref => ref.type.includes("TELEPHONE"))[0]
        .value;
    } else {
      return "";
    }
  }

  get storeFax() {
    if (this.hasStoreFax) {
      return this.$store.getters[
        "customer/storeInfo"
      ].contactReferences.filter(ref => ref.type.includes("FAX"))[0].value;
    } else {
      return "";
    }
  }

  get storeCity() {
    if (this.$store.getters["customer/storeAddresses"].length > 0) {
      return this.$store.getters["customer/storeAddresses"][0].city;
    } else {
      return "";
    }
  }

  isTodayWeekDay(day: string): boolean {
    return (
      moment(new Date())
        .format("dddd")
        .toString()
        .toLowerCase() === day
    );
  }

  onItemSelect(item: Navigation) {
    if (this.$route.name !== item.route)
      if ((window as any).dataLayer) {
        const layerData = {
          event: "click_header_menu_level1",
          event_data: {
            click_text: this.$i18n.t(item.key, { lng: "en" })
          }
        };
        (window as any).dataLayer.push(layerData);
      }
    this.$router.push({ name: item.route });
  }

  toggleSidebar() {
    this.userSidebarIsOpened = !this.userSidebarIsOpened;
  }

  get username() {
    return this.$store.getters.user.username;
  }

  getHours(): BusinessHourDTO[] | null {
    if (
      this.$store.getters["customer/storeInfo"] &&
      this.$store.getters["customer/storeInfo"].store &&
      this.$store.getters["customer/storeInfo"].store.businessHours
    ) {
      return this.$store.getters["customer/storeInfo"].store.businessHours;
    } else {
      return null;
    }
  }

  parseHours(ranges: RangeTimeDTO[]): string {
    const morning = ranges.filter((r: RangeTimeDTO) => r.name == "MORNING")[0];
    const afternoon = ranges.filter(
      (r: RangeTimeDTO) => r.name == "AFTERNOON"
    )[0];
    const morningHours = this.formatRange(morning);
    const afternoonHours = this.formatRange(afternoon);

    let hours = morningHours;
    if (afternoonHours !== "") {
      hours = morningHours + " / " + afternoonHours;
    }

    return hours;
  }

  formatRange(range: RangeTimeDTO): string {
    let start = range.fromRange;
    if (start.includes(":")) {
      start =
        String("00" + start.split(":")[0]).slice(-2) +
        ":" +
        String("00" + start.split(":")[1]).slice(-2);
    }
    let end = range.toRange;
    if (end.includes(":")) {
      end =
        String("00" + end.split(":")[0]).slice(-2) +
        ":" +
        String("00" + end.split(":")[1]).slice(-2);
    }

    let hours = start;
    if (end != "") {
      hours = start + "-" + end;
    }

    return hours;
  }

  getHoursByDay(day: string) {
    const hours = this.getHours();
    if (hours != null) {
      const filtered_hours = hours.filter((item: any) => item.day == day)[0];
      const hoursStr = this.parseHours(filtered_hours.rangeTime);
      return hoursStr !== "" ? hoursStr : this.$t("closed");
    } else {
      return "";
    }
  }

  triggerVersionCheck() {
    this.$store.dispatch("versionCheck");
  }

  @Watch("$store.getters.language")
  langugeChanged() {
    this.setDropDownMenuItems();
  }

  enabledApiKey() {
    return (
      this.$store.getters.features.apikeyv2 &&
      this.$store.getters["customer/config"].apykeyEnabled
    );
  }
}
